// Shared by the results table and the article Markdown, which renders the same figures.
export type MetricRow = {
  label: string
  note: string
  noSearch: string
  search: string
  /** Opacity (%) of the Search cell's accent background; each section fades from 100. */
  accentOpacity: number
}

export type Section = {
  title: string
  rows: MetricRow[]
}

export const sections: Section[] = [
  {
    title: "Across all 90 runs",
    rows: [
      {
        label: "Correct answers",
        note: "higher is better",
        noSearch: "70/90",
        search: "81/90",
        accentOpacity: 100,
      },
      {
        label: "Tokens per question",
        note: "mean · lower is better",
        noSearch: "547K",
        search: "262K",
        accentOpacity: 90,
      },
      {
        label: "Cost per question",
        note: "mean · lower is better",
        noSearch: "$0.38",
        search: "$0.23",
        accentOpacity: 80,
      },
      {
        label: "Agent steps",
        note: "mean · lower is better",
        noSearch: "14",
        search: "7",
        accentOpacity: 70,
      },
    ],
  },
  {
    title: "Deepest-history question",
    rows: [
      {
        label: "Correct answers",
        note: "higher is better",
        noSearch: "0/10",
        search: "10/10",
        accentOpacity: 100,
      },
      {
        label: "Time to answer",
        note: "median · lower is better",
        noSearch: "407s",
        search: "35s",
        accentOpacity: 90,
      },
    ],
  },
  {
    title: "Unprompted tool use",
    rows: [
      {
        label: "Reached for search on its own",
        note: "of 90 runs",
        noSearch: "—",
        search: "90/90",
        accentOpacity: 100,
      },
      {
        label: "Search as the very first tool call",
        note: "of 90 runs",
        noSearch: "—",
        search: "66/90",
        accentOpacity: 90,
      },
    ],
  },
]

export const searchmarkSummary = "9 questions · 10 runs each · 180 runs total"
